// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__1mnW6","col":"styles_col__1XMhf","fulfillmentStatus":"styles_fulfillmentStatus__1U_LO","emailCol":"styles_emailCol__3Gf37"};